export default "__VITE_ASSET__5U13hpiB__"